module.exports = __webpack_public_path__ + "img/testim3.11ae43a9.webp";